/* eslint semi: 1, react/prop-types:1 */

import React from 'react';

const Footer = () => {

    const styles = {
        container: {
            position: 'absolute',
            left: 0,
            bottom: 0,
            paddingTop: 20,
            paddingBottom: 20,
            backgroundColor: '#000',
            width: '100%'
        },
        text: {
            textAlign: 'center',
            color: '#FFF',
            marginBottom: 0
        }
    };

    return (
        <div className="container-fluid" style={styles.container}>
            <p style={styles.text}>{'Copyright © 2016 by FMOSoft'}</p>
        </div>
    );
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/footer.js
 **/